const ComplementoOperacionesconderivadosRules = {
    MontGanAcum: [
        'required',
        'decimal:6',
    ],
    MontPerdDed: [
        'required',
        'decimal:6',
    ],
};

export default ComplementoOperacionesconderivadosRules;